import styled from "styled-components";

export const ViewMenuLateral = styled.aside`
  display: contents;
  .view-menu-lateral {
    position: fixed;
    z-index: 200;
    width: 7%;
    min-width: 120px;
    height: 100vh;
    transition: 0.2s;
    
    .fixedContainer {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      background: ${(props) => props.theme.colors.white};
      padding: 4rem 0px 4rem 0px;
      border-radius: 0px 45px 45px 0px;
      left: 0;

      .logoConecta {
        svg {
          height: 10rem;
          width: 10rem;
          object-fit: contain;
          fill: ${(props) => props.theme.colors.primary};
        }
        cursor: pointer;
      }

      .menus,
      .logoPerfil {
        display: flex;
        flex-direction: column;
        width: 100%;

        .menuContainer {
          display: flex;
          position: relative;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          color: ${(props) => props.theme.colors.tertiary};
          padding: 3rem 0px;
          width: 100%;
          cursor: pointer;
          &::after {
            content: "";
            border-radius: 30px;
            position: absolute;
            left: 0;
            top: 0;
            width: 5px;
            height: 100%;
            background-color: ${(props) => props.theme.colors.secondary};
            transform: scaleY(0);
            transition: 250ms ease-in-out;
          }

          .menu {
            svg {
              width: 100%;
              height: 100%;
            }
          }
        }

        .ativo {
          color: ${(props) => props.theme.colors.secondary};
          font-weight: bold;
          display: flex;
          flex-wrap: nowrap;
          white-space: normal;
          &::after {
            transform: scaleY(1);
          }

          .icone-svg {
            fill: ${(props) => props.theme.colors.secondary};
          }
        }
      }

      .perfil-wrapper {
        position: relative;
        width: 100%;
      }

      .submenu-perfil {
        position: absolute;
        left: 100%;
        bottom: 0;
        background: ${(props) => props.theme.colors.white};
        border-radius: 16px;
        padding: 0.8rem 0;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        min-width: 150px;
        z-index: 300;

        .submenu-item {
          padding: 1.2rem 2rem;
          color: ${(props) => props.theme.colors.tertiary};
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 4px;
          white-space: nowrap;

          .icone-svg{
            width: 14px;
            height: 14px;
            flex-shrink: 0;
            fill: ${(props) => props.theme.colors.tertiary};
            svg{

            }
          }
        }
      }
    }

    @media (max-width: 1024px) {
      position: fixed;
      width: 100%;
      height: 12rem;
      z-index: 200;
      overflow: hidden;
      transform: translateY(100%);
      left: 0;
      bottom: 0;
      &.ios{
        height: 11rem;
        .fixedContainer{
          padding: 0px 4rem;
        }
      }

      .fixedContainer {
        flex-direction: row;
        justify-content: center;
        padding: 0px 4rem;
        border-radius: 32px 32px 0px 0px;
        width: 100%;
        border-top: 1px solid ${(props) => props.theme.colors.skeleton2};

        .menus,
        .logoPerfil {
          flex-direction: row;
          justify-content: space-evenly;
          height: 100%;
          width: 100%;

          .menuContainer {
            height: 100%;
            width: auto;
            padding: 1.5rem 2rem;

            &::after {
              content: "";
              border-radius: 30px;
              position: absolute;
              left: auto;
              right: auto;
              top: 0;
              width: 100%;
              height: 3px;
              opacity: 0;
              transform: scaleX(0);
              background-color: ${(props) => props.theme.colors.secondary};
              transition: 500ms ease;
            }

            .menu {
              @media (max-width: 650px) {
                width: 16px;
                min-width: 16px;
                height: 16px;
                min-height: 16px;
              }
            }
            .nomeMenu {
              height: auto;
              transition: 500ms ease;
              opacity: 1;
              display: block;
            }
          }

          .ativo {
            @media (max-width: 1024px) {
              .nomeMenu {
                opacity: 1;
                display: block;
                transform: scaleX(1);
                width: 100%;
                animation: 500ms reveal ease;
                overflow: hidden;

                @keyframes reveal {
                  from {
                    width: 0px;
                  }
                  to {
                    width: 100%;
                  }
                }
              }
              height: 100%;

              &::after {
                content: "";
                border-radius: 30px;
                position: absolute;
                left: auto;
                right: auto;
                top: 0;
                width: 100%;
                height: 3px;
                opacity: 1;
                background-color: ${(props) => props.theme.colors.secondary};
                transform: scaleX(1);

                @media (max-width: 450px) {
                  width: 80%;
                }
              }
            }
          }
        }
      }
    }
  }
  .bottomAtivo {
    @media (max-width: 1024px) {
      transform: translateY(0);
    }
  }
`;
